// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2isWh","col":"styles_col__1ZG8W","fulfillmentStatus":"styles_fulfillmentStatus__23q9J","emailCol":"styles_emailCol__2_vTp"};